import React from "react";
import SaveSnapshotButton from "layout/discovery/header/snapshots/SaveSnapshotButton";
import SnapshotsDropdown from "layout/discovery/header/snapshots/SnapshotsDropdown";

const SnapshotsControls = () => (
  <div
    className="discovery_snapshots_controls"
    data-testid="discovery-snapshot-controls"
  >
    <SaveSnapshotButton />
    <div className="discovery_snapshots_controls__divider" />
    <SnapshotsDropdown />
  </div>
);

export default SnapshotsControls;
